/**
 * COMMERCE-WORKSPACE-FRAMEWORK-000001 — honest KPI helpers.
 * Never invent aggregates. Prefer N/A when full result is unknown.
 */

/** Format number or honest N/A (never coerce missing to 0 for founder KPIs). */
export function formatHonestCount(n: number | null | undefined): string {
  if (n == null) return 'N/A';
  return n.toLocaleString();
}

/**
 * Full-catalog status buckets are only trustworthy when the API page holds
 * every matching row and no residual filters hide rows.
 */
export function isFullCatalogKnown(opts: {
  totalCount?: number | null;
  returnedCount?: number | null;
  rowCount: number;
  hasFilter?: boolean;
}): boolean {
  const totalDb = opts.totalCount ?? null;
  const returned = opts.returnedCount ?? opts.rowCount;
  return (
    totalDb != null && totalDb === returned && opts.rowCount === returned && !opts.hasFilter
  );
}
